import React from "react";

import Background from './BackgroundHome';
import HomeContainer from './home-container';



export default function Home(props){
    return(
        <>
        <Background/>
        <HomeContainer name="ShreePrasad Das" paragraph="Elevate your digital presence with Shreeprasad Das. Offering expertise
              in both front and backend development, I bring your vision to life
              with precision and flair. Ready to make an impact? Let's collaborate"/>
        </>
    )
}
